// test1051
(1051 && 0);
